import React from "react";

function UnderConstructionDialog({ title = "Under construction", message }) {
  return (
    <div className="p-4">
      <div className="d-flex flex-column text-center gap-2 align-items-center">
        <i
          className="bi bi-tools text-warning"
          style={{ fontSize: "3rem" }}
          aria-hidden
        />
        <div className="d-flex flex-column gap-1 container-fluid align-items-center">
          <h2 className="fw-bold m-0">{title}</h2>
          <p
            className="fs-6 m-0 col-11 text-dark"
            style={{ lineHeight: "1.2rem", fontSize: "1.2rem" }}
          >
            {message ||
              "This feature is currently under construction. Please check back later."}
          </p>
        </div>
      </div>
    </div>
  );
}

export default UnderConstructionDialog;
